import { useEffect } from 'react';
import { Navigate, RouteObject } from 'react-router-dom';
import { AuthLayout } from '@/pages/AuthLayout';
import { AuthContainer } from '@/widgets/AuthContainer';
import { LoginForm } from '@/features/LoginForm';
import { RegistrationStepper } from '@/widgets/RegistrationStepper';
import { SuccessAsync as Success } from '@/features/RegistrationForm/ui/Success/Success.async';
import { NotFound } from '@/pages/NotFound';
import { RecoveryForm } from '@/features/RecoveryForm';
import { RecoveryCodeForm } from '@/features/RecoveryCodeForm';
import { ChangePasswordForm } from '@/features/ChangePasswordForm';
import { LiveTournamentPage } from '@/pages/LiveTournamentPage';
import { PRIVACY_POLICY_PDF, getUserAgreementPdf } from '@/shared/lib/env';

const UserAgreementRedirect = (): null => {
  useEffect(() => {
    window.location.replace(getUserAgreementPdf());
  }, []);
  return null;
};

const PrivacyPolicyRedirect = (): null => {
  useEffect(() => {
    window.location.replace(PRIVACY_POLICY_PDF);
  }, []);
  return null;
};

export const noAuthConfig: RouteObject[] = [
  {
    path: '/docs/user-agreement',
    element: <UserAgreementRedirect />,
  },
  {
    path: '/docs/privacy-policy',
    element: <PrivacyPolicyRedirect />,
  },
  {
    path: '/live/tournaments/:publicId',
    element: <LiveTournamentPage />,
  },
  {
    element: <AuthLayout />,
    errorElement: <NotFound />,
    children: [
      {
        path: '/auth',
        element: <AuthContainer />,
        children: [
          {
            path: 'login',
            element: <LoginForm />,
          },
          {
            path: 'registration',
            element: <RegistrationStepper />,
          },
        ],
      },
      {
        path: '/success',
        element: <Success />,
      },
      {
        path: '/recovery',
        element: <RecoveryForm />,
      },
      {
        path: '/recovery/code',
        element: <RecoveryCodeForm />,
      },
      {
        path: '/recovery/change-password',
        element: <ChangePasswordForm />,
      },

      {
        path: '*',
        element: <Navigate to="/auth/login" replace />,
      },
    ],
  },
];
